import React, { useContext, useEffect, useState } from "react";
import { BuyersGuideModalContext } from "./BuyersGuideModalContext";
import closeSvg from "../../../assets/closeSvg";
import { AppContext } from "../../../AppContext";

const BuyersGuideModal = () => {
  const { buyersGuide, buyersGuideEditable } = useContext(AppContext);

  const { buyersGuideVisible, setBuyersGuideVisible } = useContext(
    BuyersGuideModalContext
  );

  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <div className={`ModalPage ${buyersGuideVisible ? "" : "hidden"}`}>
      <div
        className="Modal-background"
        onClick={() => {
          setBuyersGuideVisible(false);
          setLinkCopied(false);
        }}
      ></div>
      <div className="Modal-container">
        <div className="Modal">
          <div className="spaceBetween">
            <b>Buyer's Guide</b>
            <div
              className="Modal-close"
              onClick={() => {
                setBuyersGuideVisible(false);
                setLinkCopied(false);
              }}
            >
              {closeSvg}
            </div>
          </div>
          <div className="addTextPanel">
            <div className="addText centered">To view/download:</div>
            <span
              className="blue underline hover"
              onClick={() => {
                alert(
                  `To download, open in Canva:\n1. Click "Share"\n2. Click "Download" \n3. Set file type to "PDF Standard"\n4. Click "Download"`
                );
              }}
            >
              How to Download
            </span>
            <div className="tenPx"></div>
            <div
              className="button"
              onClick={() => {
                window.open(buyersGuideEditable, `_blank`);
              }}
            >
              Open in Canva
            </div>
            <div className="tenPx"></div>
          </div>
          <div className="addTextPanel">
            <div className="addText centered">To share:</div>
            <div className="tenPx"></div>
            <div
              className={linkCopied ? "button grey pressed" : "button"}
              onClick={() => {
                setLinkCopied(true);
                navigator.clipboard.writeText(buyersGuide);
              }}
            >
              {linkCopied ? "Copied!" : "Copy Link"}
            </div>
            <div className="tenPx"></div>
            <div
              className="button"
              onClick={() => {
                window.open(
                  `sms:///&body=Check out my Buyer's Guide! ${buyersGuide}`,
                  `_blank`
                );
              }}
            >
              Send via{" "}
              {navigator.userAgent.match(/Apple/i) ? "iMessage" : "Text"}
            </div>
            <div className="tenPx"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyersGuideModal;
